import * as React from 'react';
import { ReportMessages } from 'src/components/organisms/ReportMessages';
import { CaseTypeEnum, Message } from 'src/types';
import { ReportMessagesDrawer } from './ReportMessagesDrawer';

interface Props {
  isLegacyMode?: boolean;
  open: boolean;
  setTranslateMessages: (translateMessage: boolean) => void;
  messages: Message[];
  closeMessages: () => void;
  sendMessage: (channel: string) => void;
  draftMessage: string;
  updateDraftMessage: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isAssignee: boolean;
  caseId: string;
  channel: string;
  isLoading: boolean;
  caseDisplayId?: string;
  caseStatus?: string;
  caseType?: CaseTypeEnum;
}

export const ReportMessagesPanel = ({
  isLegacyMode,
  caseStatus,
  caseType,
  ...props
}: Props) => {
  if (isLegacyMode) {
    return <ReportMessages {...props} />;
  }
  return (
    <ReportMessagesDrawer
      {...props}
      caseStatus={caseStatus}
      caseType={caseType}
    />
  );
};
